export const sirenaApiKey = process.env.REACT_APP_API_KEY || "";
